import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import MinicrudsLoader, { useMinicruds } from '../_load/MinicrudsLoader'

const MinicrudsFilterSideModal = ({ label, field, entity, onClose, ...props }) => {
  field = field || 'typeIds'
  label = label || 'Tipos'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <CheckboxesFilterSideModal
      label={label}
      value={value}
      dataHook={useMinicruds}
      loaderProps={{ entities: entity }}
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      Loader={MinicrudsLoader}
      useSearch
      {...props}
    />
  )
}

export default MinicrudsFilterSideModal
